module.exports = __webpack_public_path__ + "img/eg_logo.a863e7e0.png";